import { useEffect, useState } from 'react';
import { LoadingScreen } from './LoadingScreen';
import { Button } from '../ui/button';
import { AlertTriangle } from 'lucide-react';
import { api } from '@/lib/api/client';

export function ApiLoadingScreen({ children }: { children: React.ReactNode }) {
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [retryCount, setRetryCount] = useState(0);
  const maxRetries = 3;

  useEffect(() => {
    let mounted = true;

    async function setupAdmin() {
      try {
        // Try to create default admin
        await api.post('api/auth/setup-admin', {
          phoneNumber: '00966500000000',
          password: '123456'
        });
        
        if (mounted) {
          setIsReady(true);
          setError(null);
        }
      } catch (error) {
        if (!mounted) return;

        if (retryCount < maxRetries) {
          setRetryCount(prev => prev + 1);
          setTimeout(setupAdmin, 1000);
        } else {
          setError('فشل الاتصال بالخادم. يرجى تحديث الصفحة وإعادة المحاولة.');
        }
      }
    }

    setupAdmin();

    return () => {
      mounted = false;
    };
  }, [retryCount]);

  if (error) {
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-sm p-6 max-w-md w-full text-center">
          <AlertTriangle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <h1 className="text-xl font-semibold text-gray-900 mb-4">
            {error}
          </h1>
          <Button
            onClick={() => window.location.reload()}
            className="w-full"
          >
            تحديث الصفحة
          </Button>
        </div>
      </div>
    );
  }

  if (!isReady) {
    return <LoadingScreen />;
  }

  return children;
}